import { useState, useEffect } from "react";
import axios from "../../utils/axiosInstance";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const OrdersReport = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const fetchReport = async () => {
    try {
      setLoading(true);
      const res = await axios.get("/reports/orders");
      setData(res.data);
    } catch (err) {
      console.error("Error loading orders report", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  if (loading || !data)
    return (
      <div className="text-center p-5 text-muted">
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-2">Loading Orders Report...</p>
      </div>
    );

  return (
    <div className="orders-report container-fluid py-3">
      {/* عنوان */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold mb-0">Orders Overview</h2>
        <button className="btn btn-outline-primary btn-sm" onClick={fetchReport}>
          <i className="bi bi-arrow-clockwise me-1"></i> Refresh
        </button>
      </div>

      {/* خلاصه شاخص‌ها */}
      <div className="row g-3 mb-4">
        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm h-100 text-center">
            <div className="card-body">
              <p className="text-muted mb-1">Total Orders</p>
              <h3 className="fw-bold text-primary">{data.totalOrders}</h3>
              <small className="text-secondary">All received orders</small>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm h-100 text-center">
            <div className="card-body">
              <p className="text-muted mb-1">Avg. Processing Time</p>
              <h3 className="fw-bold text-success">{data.avgProcessingTime} Days</h3>
              <small className="text-secondary">From order to delivery</small>
            </div>
          </div>
        </div>

        <div className="col-12 col-md-4">
          <div className="card border-0 shadow-sm h-100 text-center">
            <div className="card-body">
              <p className="text-muted mb-1">Pending Orders</p>
              <h3 className="fw-bold text-warning">
                {data.ordersByStatus.find((s) => s._id === "Pending")?.count || 0}
              </h3>
              <small className="text-secondary">Awaiting processing</small>
            </div>
          </div>
        </div>
      </div>

      {/* سفارش‌ها براساس وضعیت */}
      <div className="card border-0 shadow-sm mb-4">
        <div className="card-body">
          <h5 className="fw-semibold mb-3">Orders by Status</h5>
          <div className="table-responsive">
            <table className="table align-middle table-striped mb-0">
              <thead>
                <tr>
                  <th>Status</th>
                  <th>Count</th>
                  <th>Percentage</th>
                </tr>
              </thead>
              <tbody>
                {data.ordersByStatus.map((s) => {
                  const percent = ((s.count / data.totalOrders) * 100).toFixed(1);
                  return (
                    <tr key={s._id}>
                      <td>{s._id}</td>
                      <td>{s.count}</td>
                      <td style={{ width: "150px" }}>
                        <div className="progress" style={{ height: "6px" }}>
                          <div
                            className={`progress-bar ${
                              s._id === "Completed"
                                ? "bg-success"
                                : s._id === "Pending"
                                ? "bg-warning"
                                : s._id === "Cancelled"
                                ? "bg-danger"
                                : "bg-secondary"
                            }`}
                            style={{ width: `${percent}%` }}
                          ></div>
                        </div>
                        <small className="text-muted">{percent}%</small>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/*  رشد سفارش‌ها */}
      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <h5 className="fw-semibold mb-3">Order Growth (Last Months)</h5>
          {data.ordersGrowth.length === 0 ? (
            <p className="text-muted">No growth data available.</p>
          ) : (
            <div style={{ width: "100%", height: 300 }}>
              <ResponsiveContainer>
                <LineChart
                  data={data.ordersGrowth}
                  margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="count"
                    stroke="#007bff"
                    strokeWidth={2}
                    dot={{ r: 4 }}
                    activeDot={{ r: 6 }}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrdersReport;
